import { jsxs as u, jsx as r } from "@emotion/react/jsx-runtime";
import { Checkbox as m } from "@partoohub/ui";
import { useBusinessModalContext as b } from "../../../../BusinessModalContext.js";
import { selectGroup as f } from "../../../../reducer/businessModal.actions.js";
import { EllipsisText as h } from "../Section.styled.js";
import { StyledStack as x } from "./Group.styled.js";
const _ = ({
  group: s
}) => {
  const {
    dispatch: i,
    preFilters: n,
    readOnlyFilters: c
  } = b(), {
    id: e,
    name: l,
    business_count: d
  } = s, o = c?.enabledGroupIds ?? [], t = o.length !== 0 && !o.includes(e), a = n?.selectedGroupIds?.includes(e.toString()) ?? !1, p = () => {
    t || i(f(e.toString()));
  };
  return d === 0 ? null : /* @__PURE__ */ u(x, { direction: "row", justifyContent: "space-between", onClick: p, isDisabled: t, children: [
    /* @__PURE__ */ r(h, { disabled: t, children: l }),
    /* @__PURE__ */ r(m, { dataTrackId: "group_section__checkbox", "aria-label": "", checked: a, disabled: t })
  ] }, e);
};
export {
  _ as Group
};
